import { computed as r } from "vue";
function f(n, o) {
  return r(() => {
    for (const t of o)
      if (n[t] !== void 0)
        return n[t];
    return n[o[o.length - 1]];
  });
}
export {
  f as default
};
